<template>
  <div class="bespread-wrap module-layer2">
    <div class="screen-container">
      <img
        src="../../assets/img/layer2/cha2.png"
        alt=""
        srcset=""
        class="cha-r-b"
      />
      <div class="kv-content">
        <img
          src="../../assets/img/layer2/title.png"
          alt=""
          srcset=""
          class="title"
        />
        <div class="kv-reg">
          <img
            src="../../assets/img/layer2/reg-lf.png"
            alt=""
            srcset=""
            class="reg-lf"
          />
          <div class="reg-lr">
            <reg @handleFIndex="handleFIndex($event)" />
          </div>
        </div>
        <img
          src="../../assets/img/layer2/cha.png"
          alt=""
          srcset=""
          class="cha-cat"
        />
      </div>
    </div>
  </div>
</template>
<script>
import reg from "./reg.vue";

export default {
  components: {
    reg
  },
  name: "app",

  data() {
    return {
      // arrowFlag: true,
      // buiFlag: true
      
    };
  },
  watch: {},
  created() {},
  methods: {
    handleReg() {},
    handleFIndex(val) {
       this.$emit('handleMenuIndex', val)
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer2 {
  // pointer-events: none;
  background-image: url("../../assets/img/layer2/bg.png ");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .screen-container {
    width: 100%;
    position: relative;
    .cha-r-b {
      position: absolute;
      bottom: -50%;
      right: 5.5vw;
      height: 1080px;
      width: auto;
    }
    .kv-content {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 50%;
      // top: 2vw;
      transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .title {
        width: auto;
        height: 218px;
      }
      .kv-reg {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: -5.5vw;
        gap: 4vw;
        .reg-lf {
          width: 493px;
          height: auto;
        }
        .reg-lr {
          width: 550px;
        }
      }
    }
    .cha-cat {
      width: 179px;
      height: auto;
      margin-top: -7.5vw;
      margin-left: 4vw;
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer2 {
    .kv-content {
      // bottom: 2vw !important;
    }
  }
}

@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer2 {
    .kv-content {
      // bottom: 3vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer2.vue